import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { SET_SEARCH_ENGINE_STATUS } from './types';
export default _defineProperty({}, SET_SEARCH_ENGINE_STATUS, function (state, payload) {
  var currentState = state;
  currentState.isSearchEngine = payload;
});